// src/components/ProtectedRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Typography, Paper, Alert } from '@mui/material';
import { canAccessFeature, normalizePermissionLevel } from '../utils/permissions';

export default function ProtectedRoute({ children, requiredFeature, redirectTo = '/dashboard' }) {
  const [userPermission, setUserPermission] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const adminUser = localStorage.getItem('adminUser');
    if (adminUser) {
      try {
        const user = JSON.parse(adminUser);
        setUserPermission(normalizePermissionLevel(user.permissionLevel));
      } catch (err) {
        console.error('Error parsing user data:', err);
        setUserPermission(null);
      }
    } else {
      setUserPermission(null);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  // Check if user is logged in
  if (!userPermission) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has required permissions for this feature
  if (requiredFeature && !canAccessFeature(userPermission, requiredFeature)) {
    return (
      <Box sx={{ p: 4, display: 'flex', justifyContent: 'center' }}>
        <Paper sx={{ p: 4, maxWidth: 600, textAlign: 'center' }}>
          <Alert severity="warning" sx={{ mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Access Restricted
            </Typography>
            <Typography variant="body1">
              You don't have permission to access this feature. 
              Contact your administrator if you believe this is an error.
            </Typography>
          </Alert>
          <Typography variant="body2" color="text.secondary">
            Required permission level not met for this resource.
          </Typography>
        </Paper>
      </Box>
    );
  }

  return children;
}
